import React, { ComponentProps } from 'react'

import { styled, getTokenValue, Token } from 'tamagui'

import { GuildIcon, GuildIconKeys } from '../components/GuildIcon/GuildIcon'

const StyledGuildIcon = styled(GuildIcon, {
  variants: {
    size: {
      '...size': (size) => {
        // Cast to Token since variant spread syntax ('...size') passes SizeTokens
        const sizeToken = size as Parameters<typeof getTokenValue>[0]
        return {
          width: getTokenValue(sizeToken, 'size'),
          height: getTokenValue(sizeToken, 'size'),
          minWidth: getTokenValue(sizeToken, 'size'),
          minHeight: getTokenValue(sizeToken, 'size'),
        }
      },
    },
  },

  defaultVariants: {
    size: '$5',
  },
} as const)

export const Icon = StyledGuildIcon.styleable(
  (
    {
      name,

      ...props
    }: {
      name: GuildIconKeys
    } & ComponentProps<typeof StyledGuildIcon>,
    ref
  ) => {
    return <StyledGuildIcon ref={ref} {...props} name={name} />
  }
)
